import * as React from 'react';
import {FC, JSX} from "react";
import {GoodNewsTable} from "./view/GoodNews.table.tsx";
import Profile from "../../Model/Profile.ts";

export interface GoodNewsProps {
    token: string;
    profile: Profile;
}

export const GoodNews: FC<GoodNewsProps> = (props):JSX.Element => {
    return (
            <GoodNewsTable {...props}/>
    );
};